// @ts-nocheck 04bff4ce
import constants from '#packages/constants';
import * as helpIds from '#packages/helpIds';
import gfppDataUtils from '../../utils/gfppDataUtils';
import { animationGfppUtils } from '../../index';

const { ACTIONS } = constants.ROOT_COMPS.GFPP;

const animationPanelOverrides = {
  helpId: helpIds.ANIMATION.CLOSE_BUTTON,
  customizeHelpId: helpIds.ANIMATION.CUSTOMIZE_CLOSE_ICON_BUTTON,
};

export default {
  mainActions: [
    {
      label: 'gfpp_mainaction_textbutton2',
      isSelected: gfppDataUtils.getPanelStateFn(ACTIONS.SETTINGS),
      onClick: gfppDataUtils.getTogglePanelFn(ACTIONS.SETTINGS),
    },
  ],
  enabledActions: [
    ACTIONS.LINK,
    ACTIONS.DESIGN,
    ACTIONS.LAYOUT,
    ACTIONS.ANIMATION,
    ACTIONS.HELP,
  ],
  mobileMainActions: [],
  mobileEnabledActions: [
    ACTIONS.SCALE_DOWN,
    ACTIONS.SCALE_UP,
    ACTIONS.LAYOUT,
    ACTIONS.HIDE,
    ACTIONS.HELP,
    ACTIONS.ANIMATION,
  ],
  presetActions: {
    animation: {
      onClick: (editorAPI, compRefs, origin, props) =>
        animationGfppUtils.onAnimationClick(editorAPI, compRefs, origin, {
          ...props,
          ...animationPanelOverrides,
        }),
    },
    help: helpIds.UTILS.getGfppHelpIds(helpIds.COMP_TYPES.CLOSE_BUTTON),
  },
};
